import React, { useState } from "react";
import { FaCloudUploadAlt, FaTimes, FaFileCsv, FaDownload } from "react-icons/fa";
import { toast } from "react-toastify";
import { uploadLeadsCSV } from "../../services/leadService";
import "./UploadLeadModal.css";

const UploadLeadModal = ({ onClose, onSuccess }) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [uploadResult, setUploadResult] = useState(null);

  const handleUpload = async () => {
    if (!file) {
      toast.error("Please select a CSV file");
      return;
    }

    setLoading(true);
    const res = await uploadLeadsCSV(file);
    setLoading(false);

    if (res.status === "success") {
      toast.success(res.message || "Leads uploaded successfully");
      if (res.data) {
        setUploadResult(res.data);
      } else {
        onSuccess();
      }
    } else {
      toast.error(res.message || "CSV upload failed");
    }
  };

  return (
    <div className="upload-overlay">
      <div className="upload-modal">

        {/* HEADER */}
        <div className="upload-header">
          <h4>Upload Leads CSV</h4>
          <button className="close-btn" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        {/* BODY */}
        <div className="upload-body">
          {uploadResult ? (
             <div className="upload-result">
               <h5 style={{ color: '#28a745', marginBottom: '10px' }}>Upload Summary</h5>
               <p style={{ margin: '5px 0' }}><strong>Successfully Inserted:</strong> {uploadResult.inserted || 0}</p>
               <p style={{ margin: '5px 0' }}><strong>Duplicates Skipped:</strong> {uploadResult.duplicates_skipped || 0}</p>
               
               {uploadResult.duplicate_rows && uploadResult.duplicate_rows.length > 0 && (
                 <div style={{ marginTop: '15px', maxHeight: '200px', overflowY: 'auto', border: '1px solid #ddd', borderRadius: '5px' }}>
                   <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px', textAlign: 'left' }}>
                     <thead style={{ background: '#f8f9fa', position: 'sticky', top: 0 }}>
                       <tr>
                         <th style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>Row</th>
                         <th style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>Name</th>
                         <th style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>Phone</th>
                         <th style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>Reason</th>
                       </tr>
                     </thead>
                     <tbody>
                       {uploadResult.duplicate_rows.map((row, idx) => (
                         <tr key={idx}>
                           <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>{row.row}</td>
                           <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>{row.name}</td>
                           <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>{row.phone}</td>
                           <td style={{ padding: '8px', borderBottom: '1px solid #ddd', color: '#dc3545' }}>{row.reason}</td>
                         </tr>
                       ))}
                     </tbody>
                   </table>
                 </div>
               )}
               
               <button
                 className="upload-btn"
                 style={{ marginTop: '20px' }}
                 onClick={() => onSuccess()}
               >
                 Done
               </button>
             </div>
          ) : (
            <>
              <label className="upload-box">
                <FaCloudUploadAlt className="upload-icon" />
                <p>
                  {file ? "Selected File" : "Click to upload CSV"}
                </p>
                <span>Only .csv files allowed</span>

                <input
                  type="file"
                  accept=".csv"
                  onChange={(e) => setFile(e.target.files[0])}
                  hidden
                />
              </label>

              {/* FILE PREVIEW */}
              {file && (
                <div className="file-preview">
                  <FaFileCsv />
                  <span>{file.name}</span>
                </div>
              )}

              {/* ACTION */}
              <button
                className="upload-btn"
                disabled={!file || loading}
                onClick={handleUpload}
              >
                {loading ? "Uploading..." : "Upload CSV"}
              </button>

              <div style={{ textAlign: "center", marginTop: "15px" }}>
                <a
                  href="/assets/fille/sample_leads_full.csv"
                  download
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "5px",
                    color: "#4a6cf7",
                    textDecoration: "none",
                    fontSize: "14px",
                    fontWeight: "500"
                  }}
                >
                  <FaDownload /> Download Sample CSV
                </a>
              </div>
            </>
          )}
        </div>

      </div>
    </div>
  );
};

export default UploadLeadModal;
